<template>
    <div class="park-introduce">
        <!-- 标题 -->
        <div class="public-module-title">
            <img src="@/assets/images/publicTitle.png" alt="">
            <div class="special">渔歌研学</div>
        </div>

        <el-carousel ref="banner" class="banner" height="280px" :interval="5000" arrow="always" indicator-position="none">
            <el-carousel-item v-for="item in imgList" :key="item.id">
                <img :src="item.url" alt="">
            </el-carousel-item>
        </el-carousel>

        <div class="carousel2">
            <el-carousel class="banner2" ref="carousel2" height="90px" :interval="5000" arrow="never" indicator-position="none" :autoplay="false">
                <el-carousel-item v-for="(item,index) in imgList2" :key="index">
                    <div class="imgBox">
                        <img v-for="(value,idx) in item" :key="idx" :src="value.url" alt="" @click="showImg(value.id)">
                    </div>
                </el-carousel-item>
            </el-carousel>

            <div class="leftArrow" @click="prev">◀</div>
            <div class="rightArrow" @click="next">▶</div>
        </div>

        <div class="desc" ref="text" @mouseenter="enter" @mouseleave="leave">
            <p>稻乡渔歌现代农业产业园是成都市十大最美川西林盘，秉承传统耕读文化精神，为3-16岁孩子打造多场景、沉浸式的田园课堂。</p>
            <p>2022年被成都市文化广电旅游局评为“2022 TOP100——最成都·生活美学新场景”之一；稻乡渔歌研学旅行营地被省文化和旅游厅认定为“2022年度省级研学旅行实践营地创建单位”。</p>
            <p>项目打造的研学营地开展以研学教育、自然教育、生存探险、农耕文化教育、艺术教育、亲子玩乐等为主的课程及活动，将孩子培养成仁爱、坚韧、智慧、诚信且兼具艺术感知力的新时代君子。</p>
            <p>项目始终坚持“产景相容、产旅一体、产村融合”发展思路，按照“统筹规划、社会投入、群众参与、共建共享”行动步骤，深入推进“农商文旅体+”融合发展，打造“退纳稻乡渔歌•进收蜀韵田源”的乡村田园诗意生活场景。</p>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    data () {
        return {
            transit:false,
            contentShow:false,
            imgList:[
                {id:1,url:require('../../../assets/images/parkStyle/banner/img (1).jpg'),},
                {id:2,url:require('../../../assets/images/parkStyle/banner/img (2).jpg'),},
                {id:3,url:require('../../../assets/images/parkStyle/banner/img (3).jpg'),},
                {id:4,url:require('../../../assets/images/parkStyle/banner/img (4).jpg'),},
                {id:5,url:require('../../../assets/images/parkStyle/banner/img (5).jpg'),},
                {id:6,url:require('../../../assets/images/parkStyle/banner/img (6).jpg'),},
                {id:7,url:require('../../../assets/images/parkStyle/banner/img (7).jpg'),},
                {id:8,url:require('../../../assets/images/parkStyle/banner/img (8).jpg'),},
                {id:9,url:require('../../../assets/images/parkStyle/banner/img (9).jpg'),},
                {id:10,url:require('../../../assets/images/parkStyle/banner/img (10).jpg'),},
                {id:11,url:require('../../../assets/images/parkStyle/banner/img (11).jpg'),},
                {id:12,url:require('../../../assets/images/parkStyle/banner/img (12).jpg'),},
                {id:13,url:require('../../../assets/images/parkStyle/banner/img (13).jpg'),},
                {id:14,url:require('../../../assets/images/parkStyle/banner/img (14).jpg'),},
                {id:15,url:require('../../../assets/images/parkStyle/banner/img (15).jpg'),},
                {id:16,url:require('../../../assets/images/parkStyle/banner/img (16).jpg'),},
                {id:17,url:require('../../../assets/images/parkStyle/banner/img (17).jpg'),},
            ],
            imgList2:[]
        }
    },
    watch:{
    },
    created () {
    },
    destroyed(){
        clearTimeout(this.timer);
    },
    mounted () {
        this.scrollFn()
        this.imgList2 = this.arrayChunk(this.imgList,6)
    },

    methods: {
        showImg(id){
            console.log("id",id);
            this.$refs.banner.setActiveItem(this.imgList.findIndex(val => val.id == id))
        },
        arrayChunk(array, size){
            let data = []
            for (let i = 0; i < array.length; i += size) {
                data.push(array.slice(i, i + size))
            }
            return data
        },

        prev(){
            this.$refs.carousel2.prev()
        },
        next(){
            this.$refs.carousel2.next()
        },

        scrollFn(){
            const divData = this.$refs.text
            if(divData){
                this.timer=setInterval(()=>{
                    divData.scrollTop += 1;
                    if(divData.clientHeight + divData.scrollTop == divData.scrollHeight){
                        divData.scrollTop = 0
                    }
                },80)
            }
        },

        enter(){
            clearInterval(this.timer)
        },

        leave(){
            this.scrollFn()
        },
    },
}
</script>
<style lang="less" scoped>
.park-introduce{
    // 修改滚动条样式
    ::-webkit-scrollbar {
        width: 2px;    
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(22, 138, 130, 0.82);
    }
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(26, 120, 114, 0.28);
    }

    .banner{
        margin: 20px 0;
        img{
            height: 280px;
            width: 100%;
            object-fit: cover;
        }
    }

    .carousel2{
        position: relative;
        /deep/.banner2{
            .el-carousel__container{
                .el-carousel__arrow{
                    background-color: rgba(31,45,61,.8);
                }
                .el-carousel__arrow--right{
                    right: 0;
                }
                .el-carousel__arrow--left{
                    left: 0;
                }
            }
            .el-carousel__item{
                .imgBox{
                    display: grid;
                    grid-template-columns: repeat(6, 1fr);
                    gap: 8px;
                    padding: 0 15px;
                }
            }
            img{
                width: 60px;
                height: 80px;
                object-fit: cover;
            }
        }

        .leftArrow{
            color: rgba(204, 204, 204, 1);
            font-size: 16px;
            position: absolute;
            top: 50%;
            left: -6px;
            transform: translateY(-50%);
            z-index: 22;
            &:hover{
                cursor: pointer;
                color: rgba(255, 255, 255, 1);
            }
        }
        .rightArrow{
            color: rgba(204, 204, 204, 1);
            font-size: 16px;
            position: absolute;
            top: 50%;
            right: -6px;
            transform: translateY(-50%);
            z-index: 22;
            &:hover{
                cursor: pointer;
                color: rgba(255, 255, 255, 1);
            }
        }
    }

    .desc{
        width: 100%;
        height: 150px;
        overflow: auto;
        font-size: 16px;
        font-weight: 500;
        line-height: 26px;
        color: rgba(255, 255, 255, 1);
        padding: 0 10px;
        box-sizing: border-box;
        p{
            text-indent: 2em;
        }
    }
}

</style>
